import { CreateHelpAssistTicketDTO } from "mock-api/src/shared-v2-types";
import type { PostRequestData } from "src/app/core/request-v2.service";
import { HelpAssistEventType } from "../../help-assist-enums";
import type { HelpAssistTicketScheduleUpdate } from "../ticket-schedule/help-assist-ticket-appointment-schedule-update.model";
import { BaseHelpAssistTicket } from "./base-help-assist-ticket.model";

/**
 * Arguments required to construct a {@link HelpAssistTicketCreate}.
 */
export interface HelpAssistTicketCreateArgs extends ClassProperties<BaseHelpAssistTicket> {
  readonly events: readonly TicketEvent[];
  readonly orders: string | null;
  readonly schedule: HelpAssistTicketScheduleUpdate | null;
}

/**
 * This class replaces the create-specific path in {@link HelpAssistTicketUpdate},
 * producing a strongly typed {@link Api.CreateHelpAssistTicketDTO} instead of
 * a generic `Partial<ODataType>`.
 */
export class HelpAssistTicketCreate
  extends BaseHelpAssistTicket
  implements PostRequestData<"/HelpAssistTickets/CreateHelpAssistTicket">
{
  public constructor(args: HelpAssistTicketCreateArgs) {
    super(args);

    this.events = args.events;
    this.orders = args.orders;
    this.schedule = args.schedule;
  }

  public readonly events: readonly TicketEvent[];
  public readonly orders: string | null;
  public readonly schedule: HelpAssistTicketScheduleUpdate | null;

  public serialize(): CreateHelpAssistTicketDTO {
    return {
      siteId: this.site.id,
      type: this.type,
      emailAddress: this.emailAddress,
      phoneNumber: this.phoneNumber?.trim() || null,
      orders: this.orders,
      events: this.events.map((event) => ({
        comment: event.comment,
        ticketId: null,
        type: event.type,
      })),
      appointmentSchedule: this.schedule?.serializeForCreate() ?? null,
    };
  }
}

interface TicketEvent {
  readonly comment: string | null;
  readonly type: HelpAssistEventType;
}
